import {Injectable} from '@angular/core';


@Injectable()
export class LogoutService {

  constructor() {

  }

  logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('idUser');
        localStorage.removeItem('userName');
        return true;
  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/logout/logout.service.ts
 **/